import { h, render, Component } from "preact";

import { formatNumber, linkifyTeams } from "../lib/utilities";

export default class PlayerDataRow extends Component {
  render(props, state) {
    const player = props.player;

    const teamLinks = linkifyTeams(player.team_abbreviations);

    return (
      <tr class="player-stats">
        <td>
          <a href={player.url}>{player.name}</a>
        </td>
        <td>{teamLinks}</td>
        <td>{formatNumber(player.exact_position, 1)}</td>
        <td>{player.games}</td>
        <td>{formatNumber(player.minutes)}</td>
        <td>{formatNumber(player.per48_position_adj_prod, 3)}</td>
        <td>{formatNumber(player.per48_wins_produced, 3)}</td>
        <td>{formatNumber(player.wins_produced, 1)}</td>
        <td>{formatNumber(player.per48_points_over_par, 1)}</td>
        <td>{formatNumber(player.per48_points, 1)}</td>
        <td>{formatNumber(player.per48_rebounds, 1)}</td>
        <td>{formatNumber(player.per48_assists, 1)}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/player-data-row-component.js